import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'properCurrencyPipe'
})
export class ProperCurrencyPipe implements PipeTransform {

	constructor(private numberPipe:DecimalPipe) {}

	transform(number:number|string|undefined) : string|null {
		if (number == undefined)
			return null;

		let n = number as number;
		if (isNaN(n))
			return "NaN";
		
		if (n % 1 == 0) {
			return "$ "+ this.numberPipe.transform(n, "1.0");
		} else {
			return "$ "+ this.numberPipe.transform(n, "1.2-2");
		}
	}

}
